import { render, staticRenderFns } from "./GrupaStatusaCreate.vue?vue&type=template&id=79f0efa4&scoped=true&"
import script from "./GrupaStatusaCreate.vue?vue&type=script&lang=js&"
export * from "./GrupaStatusaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f0efa4",
  null
  
)

export default component.exports